import { useMemo } from 'react';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { SCREENS } from '../../constants/tracking/Screens';
import { useSortedProductInventory } from '../../hooks/inventory/useSortedProductInventory';
import { useOwnedBundleForProduct } from '../../hooks/inventory/useProductInventory';
import { getNavItemForProductLine } from '../../../utils/routingUtils';
import { isValidProductLine } from '../../utils/typeguards';
import { withErrorBoundary } from '../error-boundary/withErrorBoundary';
import { CustomError } from '../error-boundary/CustomErrors';
import HubSpotCreditsFeatures from '../../../components/key-features/HubSpotCreditsFeatures';
import { SingleSkeletonLoader } from '../SingleSkeletonLoader';
import { jsx as _jsx } from "react/jsx-runtime";
const UnlockAIContentBase = () => {
  const isMobile = useIsMobile();
  const {
    sortedProductInventory,
    loading: sortedProductInventoryLoading,
    error: sortedProductInventoryError
  } = useSortedProductInventory();
  const firstProduct = sortedProductInventory[0];

  // Get bundle type for the first product if it exists
  const {
    bundleType,
    loading: bundleTypeLoading,
    error: bundleTypeError
  } = useOwnedBundleForProduct({
    apiName: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productApiName
  });
  const isLoading = sortedProductInventoryLoading || bundleTypeLoading;
  const subscreen = useMemo(() => {
    const isBundle = !!(firstProduct !== null && firstProduct !== void 0 && firstProduct.bundle);
    if (isBundle) {
      if (bundleType === 'MARKETING_PLUS_SUITE') {
        return SCREENS.MARKETING_PLUS;
      }
      if (bundleType === 'CRM_SUITE') {
        return SCREENS.SUITE;
      }
    }
    const productLine = firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productLine;
    if (!isValidProductLine(productLine)) {
      return SCREENS.SUITE;
    }
    return getNavItemForProductLine(productLine);
  }, [firstProduct, bundleType]);
  if (sortedProductInventoryError) throw new CustomError('Failed getting sorted product inventory', {
    error: sortedProductInventoryError
  });
  if (bundleTypeError) throw new CustomError('Failed getting bundle type from product', {
    error: bundleTypeError
  });
  if (isLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 1000,
      width: "100%"
    });
  }
  if (isMobile) {
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      padding: "0",
      children: /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })
    });
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    padding: "1300",
    borderRadius: "300",
    borderWidth: "100",
    blockSize: "100%",
    marginBlock: "0",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })
    })
  });
};
export const UnlockAIContent = withErrorBoundary(UnlockAIContentBase, {
  fallback: null,
  errorBoundaryName: 'UnlockAIContent'
});